import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { authService } from '../services/api';
import PasswordInput from '../components/PasswordInput';
import ConfirmPopup from '../components/ConfirmPopup';
import './Login.css';

const Login = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    email: '',
    password: '',
  });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
    setError('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const response = await authService.login(formData);
      // Verificar si el perfil está completo
      if (response.user?.profile_complete === false) {
        navigate('/complete-profile');
      } else {
        navigate('/dashboard');
      }
    } catch (err) {
      const d = err.response?.data;
      const detail = d?.detail;
      const detailMsg = Array.isArray(detail) ? detail[0] : detail;
      setError(
        d?.non_field_errors?.[0] ||
        detailMsg ||
        d?.message ||
        (err.response?.status === 403
          ? 'Acceso denegado (403). Si usás el admin en el mismo navegador, probá ventana privada o cerrá sesión en /admin/. Si persiste, contactá al administrador.'
          : null) ||
        'Error al iniciar sesión. Verifica tus credenciales.'
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login">
      <div className="login-container">
        <div className="login-card">
          <h2 className="login-title">Iniciar Sesión</h2>
          <p className="login-subtitle">Ingresa a tu cuenta del Campus Virtual</p>

          <ConfirmPopup
            open={Boolean(error)}
            title="Error"
            message={error}
            confirmLabel="Aceptar"
            cancelLabel={null}
            onConfirm={() => setError('')}
            onCancel={() => setError('')}
            variant="danger"
          />

          <form onSubmit={handleSubmit} className="login-form">
            <div className="login-form-group">
              <label htmlFor="email" className="login-label">
                Correo Electrónico
              </label>
              <input
                type="email"
                id="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                className="login-input"
                required
                autoComplete="email"
              />
            </div>

            <div className="login-form-group">
              <label htmlFor="password" className="login-label">
                Contraseña
              </label>
              <PasswordInput
                id="password"
                name="password"
                value={formData.password}
                onChange={handleChange}
                className="login-input"
                required
                autoComplete="current-password"
              />
            </div>

            <button
              type="submit"
              className="login-button"
              disabled={loading}
            >
              {loading ? 'Iniciando sesión...' : 'Iniciar Sesión'}
            </button>
          </form>

          <p className="login-footer">
            ¿No tienes una cuenta?{' '}
            <Link to="/register" className="login-link">
              Regístrate aquí
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
};

export default Login;

